import { CloseButton, Table } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useState } from 'react';
import { TableRowCollapsible } from '../../../components/TableRowCollapsible';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import {
	formatToCurrency,
	formatToDateString,
	formatToTimeString,
} from '../../../util/formatting';
import { undefinedCheck } from '../../../util/undefinedCheck';
import { Receipt } from '../../receipts/Receipt';
import type { TenderDto } from '../types/TenderDto';
import { KeyedRow } from '../../../components/KeyedRow';

interface TableRowProps {
	tender: TenderDto;
}

export function TendersTableRow({ tender }: TableRowProps) {
	const [receiptOpen, setReceiptOpen] = useState(false);

	return (
		<>
			<KeyedRow key={tender.dateTime.toString()}>
				<Table.Td>{tender.id}</Table.Td>
				<Table.Td>{formatToDateString(tender.dateTime)}</Table.Td>
				<Table.Td>{formatToTimeString(tender.dateTime)}</Table.Td>
				<Table.Td>{tender.tenderType}</Table.Td>
				<Table.Td>{formatToCurrency(tender.amount)}</Table.Td>
				<Table.Td>
					{tender.change !== 0 ? (
						formatToCurrency(tender.change)
					) : (
						<>
							<i>No Change</i>
						</>
					)}
				</Table.Td>
				<Table.Td>{undefinedCheck(tender.currencyCode)}</Table.Td>
				<Table.Td>
					{tender.reportNo !== '0' ? (
						tender.reportNo
					) : (
						<>
							<i>Undefined</i>
						</>
					)}
				</Table.Td>
				<Table.Td>
					<CloseButton
						icon={
							!receiptOpen ? (
								<IconChevronDown {...defaultIconStyle} />
							) : (
								<IconChevronUp {...defaultIconStyle} />
							)
						}
						onClick={() => setReceiptOpen(!receiptOpen)}
					/>
				</Table.Td>
			</KeyedRow>
			<TableRowCollapsible isOpen={receiptOpen} columnRows={9}>
				<Receipt id={tender.id} startLoading={receiptOpen} />
			</TableRowCollapsible>
		</>
	);
}
